import { put, takeEvery, takeLatest } from 'redux-saga/effects';

import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import { messageActions } from 'Ducks';
import { GLOBALS } from 'Constants';
import userTypes from './types';
import userActions from './actions';
import userServices from './services';

function* forgetPasswordRequest(action) {
	try {
		let response = yield sagaCallService(
			userServices.forget_password,
			action,
			action.payload
		);
		yield put(userActions.forgetPasswordSuccess(response.data));
		yield put(
			messageActions.pushSuccessToast({
				title: response?.data?.msg,
				toastTime: GLOBALS.TOAST_TIMEOUT.UNSET,
			})
		);
	} catch (error) {
		yield sagaErrorDispatcher(
			error,
			{ ...action, toastTime: GLOBALS.TOAST_TIMEOUT.UNSET },
			userActions.forgetPasswordFailure
		);
	}
}

function* resetPasswordRequest(action) {
	try {
		let response = yield sagaCallService(
			userServices.reset_password,
			action,
			action.payload
		);
		yield put(userActions.resetPasswordSuccess(response.data));
		yield put(
			messageActions.pushSuccessToast({
				title: response?.data?.msg,
				toastTime: GLOBALS.TOAST_TIMEOUT.UNSET,
			})
		);
	} catch (error) {
		yield sagaErrorDispatcher(
			error,
			{ ...action, toastTime: GLOBALS.TOAST_TIMEOUT.UNSET },
			userActions.resetPasswordFailure
		);
	}
}

function* freshUserRegisterRequest(action) {
	try {
		let response = yield sagaCallService(
			userServices.fresh_register,
			action,
			action.payload
		);
		yield put(
			userActions.registerFreshSuccess({ ...response.data, ...action?.payload })
		);
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			{ ...action, toastTime: GLOBALS.TOAST_TIMEOUT.UNSET },
			userActions.registerFreshFailure
		);
	}
}

function* getProfleRequest(action) {
	try {
		let response = yield sagaCallService(
			() => userServices.profile(action.payload),
			action
		);
		yield put(userActions.profileSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, userActions.profileFailure);
	}
}

function* getProfleCompleteRequest(action) {
	try {
		let response = yield sagaCallService(
			() => userServices.profileCompelete(action.payload),
			action
		);
		if (response?.data) {
			yield put(userActions.profileGetSuccess(response?.data));
		}
	} catch (e) {
		yield sagaErrorDispatcher(e, action, userActions.profileGetFailure);
	}
}

function* updateProfleRequest(action) {
	try {
		let response = yield sagaCallService(
			() => userServices.updateProfile(action.payload),
			action
		);
		yield put(userActions.profileUpdateSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			userActions.profileUpdateFailure,
			true
		);
	}
}
function* updateProfleOTPRequest(action) {
	try {
		let response = yield sagaCallService(
			() => userServices.changeNumberOTP(action.payload),
			action
		);
		yield put(userActions.profileUpdateOTPSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, userActions.profileUpdateOTPFailure);
	}
}

function* updateProfleOTPConfirmRequest(action) {
	try {
		let response = yield sagaCallService(
			() => userServices.changeNumberOTPConfirm(action.payload),
			action
		);
		yield put(userActions.profileUpdateOTPConfirmSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			userActions.profileUpdateOTPConfirmFailure
		);
	}
}

function* userWizard(action) {
	try {
		let response = yield sagaCallService(
			userServices.userWizard,
			action,
			action.payload
		);
		yield put(userActions.profileWizardSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, userActions.profileWizardFailure);
	}
}

function* updateProfileRequest(action) {
	try {
		yield put(userActions.updateUserInfoSuccess(action?.payload));
	} catch (e) {
		console.log('GOT ERROR in updateProfileRequest');
		// yield sagaErrorDispatcher(e, action, userActions.profileWizardFailure);
	}
}

const userSagas = [
	takeLatest(userTypes.REGISTER_FRESH.REQUEST, freshUserRegisterRequest),
	takeLatest(userTypes.FORGET_PASSWORD.REQUEST, forgetPasswordRequest),
	takeLatest(userTypes.RESET_PASSWORD.REQUEST, resetPasswordRequest),
	takeEvery(userTypes.PROFILE.REQUEST, getProfleRequest),
	takeLatest(userTypes.PROFILE_UPDATE.REQUEST, updateProfleRequest),
	takeLatest(userTypes.CHANGE_NUMBER_OTP.REQUEST, updateProfleOTPRequest),
	takeLatest(userTypes.WIZARD.REQUEST, userWizard),
	takeLatest(userTypes.GET_PROFILE.REQUEST, getProfleCompleteRequest),
	takeLatest(
		userTypes.CHANGE_NUMBER_OTP_CONFIRM.REQUEST,
		updateProfleOTPConfirmRequest
	),
	takeLatest(userTypes.UPDATE_PROFILE.REQUEST, updateProfileRequest),
];

export default userSagas;
